import { Component, Input } from '@angular/core'

@Component({
   selector: 'vc-spinner',
   templateUrl: './spinner.component.html',
   styleUrls: ['./spinner.component.scss'],
   standalone: false,
})
export class SpinnerComponent {
   @Input() loading = false
}
